// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/index.css";
import * as echarts from "echarts";
import ElememntUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'
import './static/css/main.css'
Vue.prototype.echarts = echarts;
Vue.config.productionTip = false
Vue.use(ElememntUI)

require("./utils/mock.js")

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.beforeResolve((to, from, next) => {
  window.document.title = to.meta.title
  next()
})


// WEBPACK FOOTER //
// ./src/main.js